import { Pencil } from '@factorialco/f0-react/icons/app'
import DOMPurify from 'dompurify'
import { FormFragment } from 'generated/resources/graphql'

import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

type Props = {
  formTemplate: FormFragment
}

export const buildOverviewFormTemplateHeaderProps = (data: Props) => {
  const formTemplate = data?.formTemplate
  if (!formTemplate) {
    return {
      title: i18n.t('trainings.surveys.fallback_title'),
    }
  }

  const variant: 'positive' | 'neutral' = formTemplate.status === 'active' ? 'positive' : 'neutral'

  return {
    title: formTemplate.title,
    description: DOMPurify.sanitize(formTemplate.description ?? '', { ALLOWED_TAGS: [] }),
    status: {
      label: '',
      text:
        formTemplate.status === 'active'
          ? i18n.t('forms.custom_templates.data_collection.status_values.published')
          : i18n.t('forms.custom_templates.data_collection.status_values.draft'),
      variant,
    },
    metadata: [
      {
        label: i18n.t('forms.header.current_survey'),
        value: {
          type: 'text' as const,
          content: stringToDate(formTemplate.createdAt, 'backend_datetime').format('LL'),
        },
      },
    ],
    primaryAction: {
      key: 'publish',
      label:
        formTemplate.status === 'draft'
          ? i18n.t('common.publish')
          : i18n.t('forms.custom_templates.template_details.revert_to_draft'),
    },
    secondaryActions: [
      {
        key: 'edit',
        icon: Pencil,
        label: i18n.t('forms.header.edit_content'),
        disabled: formTemplate.status !== 'draft',
        loading: true,
      },
    ],
    otherActions: (() => {
      const isDraft = formTemplate.status === 'draft'

      if (!isDraft) return []

      return [
        {
          key: 'edit_settings',
          label: i18n.t('forms.header.edit'),
        },
        {
          key: 'delete',
          label: i18n.t('forms.header.delete'),
        },
      ]
    })(),
  }
}
